import React, { useState, useEffect } from "react";
import CategoryTreeSelector from "./CategoryTreeSelector";

const TradingAssetForm = ({ 
  initialData = {}, 
  onSubmit, 
  isLoading = false, 
  isEdit = false 
}) => {
  const [formData, setFormData] = useState({
    category_id: "",
    name: "",
    description: "",
    formula: "",
    ...initialData
  });
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/assets/categories?asset_class=trading`,
        {
          credentials: "include",
        }
      );
      const data = await response.json();
      setCategories(data.categories || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <CategoryTreeSelector
        categories={categories}
        selectedId={formData.category_id}
        onSelect={(category) => handleInputChange("category_id", category.id)}
        placeholder="Select category"
        label="Category"
        required={true}
      />

      <div className="space-y-2">
        <label className="block text-sm font-semibold text-slate-700">
          Asset Name *
        </label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => handleInputChange("name", e.target.value)}
          placeholder="Enter trading asset name"
          required
          className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
        />
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-semibold text-slate-700">
          Description
        </label>
        <textarea
          value={formData.description}
          onChange={(e) => handleInputChange("description", e.target.value)}
          placeholder="Enter trading asset description"
          className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
          rows="3"
        />
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-semibold text-slate-700">
          Formula
        </label>
        <input
          type="text"
          value={formData.formula}
          onChange={(e) => handleInputChange("formula", e.target.value)}
          placeholder="Enter calculation formula (optional)"
          className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
        />
      </div>

      <div className="flex space-x-4 pt-4">
        <button
          type="submit"
          disabled={isLoading}
          className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 font-semibold shadow-lg shadow-blue-500/25 transition-all duration-200 disabled:opacity-50"
        >
          <span>{isLoading ? "Saving..." : isEdit ? "Update Asset" : "Register Asset"}</span>
        </button>
      </div>
    </form>
  );
};

export default TradingAssetForm;



